import React from 'react';
import classNames from 'classnames';
import { IconButton, IconButtonVariants, IconNames } from '@hallmark/web.core.buttons.icon-button';
import { Typography, TypographyVariants } from '@hallmark/web.core.typography.typography';
import { FontSizeAction, FontSizeProps } from '../font-drawer-types';
import styles from '../font-drawer.module.scss';

export const FontSize = ({
  addClass = '',
  label,
  onClickButton,
  fontSizeValue,
  upper,
  lower,
  testId = 'font-size',
}: FontSizeProps): React.ReactElement => {
  const classes = classNames(styles['font-size'], addClass);

  const shouldDisabledRemoveButton = fontSizeValue === lower;
  const shouldDisabledAddButton = fontSizeValue === upper;

  return (
    <section className={classes} data-testid={testId}>
      <Typography variant={TypographyVariants.FieldLabel}>{label}</Typography>
      <div className={styles.counter}>
        <IconButton
          testId="decreaseFontButton"
          disabled={shouldDisabledRemoveButton}
          icon={IconNames.Remove}
          variant={IconButtonVariants.Avatar}
          click={() => onClickButton(FontSizeAction.Decrease)}
        />
        <Typography testId="fontSizeValue" variant={TypographyVariants.Body} addClass={styles.counterValue}>
          {fontSizeValue}
        </Typography>
        <IconButton
          testId="increaseFontButton"
          disabled={shouldDisabledAddButton}
          icon={IconNames.Expand}
          variant={IconButtonVariants.Avatar}
          click={() => onClickButton(FontSizeAction.Increase)}
        />
      </div>
    </section>
  );
};
